<div [formGroup]="form" [class]="className">
  <div class="tw-font-normal tw-text-gray-500 tw-text-md">{{ label }}</div>
  <div class="list-wrapper" style="position: relative">
    <div style="overflow-y: auto; overflow-x: hidden">
      <ng-select
        [loading]="loading"
        appendTo=".list-wrapper"
        [formControlName]="controlName"
        [notFoundText]="'app.no_items' | translate"
        placeholder="{{ '-- ' + placeholder + ' --' }}"
        [multiple]="multiple"
        [searchable]="searchable"
        class="{{ isError ? 'tw-border tw-border-red-500' : '' }}  "
        (change)="handleChange($event)"
        [items]="options"
        bindLabel="name"
        bindValue="value"
      />
    </div>
  </div>

  <div
    class="tw-text-sm tw-flex tw-items-center tw-gap-1 {{
      isError ? 'tw-text-red-500' : ''
    }}"
  >
    @if (isError) {
      <span class="material-icons tw-mr-1 tw-text-xl">error_outline</span>
    }
    {{ helperText }}
  </div>
</div>
